<template>
  <span class="wrapper" v-if="params.node.rowPinned !== 'bottom'">
    <span v-tooltip.bottom="{ content: tooltipContent }" :style="{ color: isDeclined ? 'red' : 'inherit' }">
      {{ params.value }}
      <i v-if="isDeclined" class="fas fa-info-circle"></i>
    </span>
  </span>
</template>

<script>
  export default {
    computed: {
      isDeclined() {
        return this.params.value.toLowerCase() === 'declined'
      },
      tooltipContent() {
        return !this.isDeclined ? this.params.value : this.getDecliningReason()
      }
    },
    methods: {
      getDecliningReason() {
        return 'Declining Reason: ' + this.params.data.DeclineReason
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/TransactionStatus.vue